import axios from "axios";

const API_BASE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net";

const RegistrationService = {
  /**
   * 🔹 Регистрирует нового пользователя по email.
   * @param {string} email - Почта пользователя.
   * @param {string} password - Пароль пользователя.
   * @returns {Promise<Object>} - { success: boolean, message?: string, error?: string }
   */
async registerUser(email, password) {
  try {
    const payload = { email, password };

    const response = await axios.post(`${API_BASE_URL}/register_user`, payload, {
      headers: { "Content-Type": "application/json" }
    });

    console.log("✅ Регистрация успешна:", response);

    return { success: true, ...response.data };
  } catch (error) {
    console.error("❌ Ошибка при регистрации (FULL):", {
      message: error.message,
      code: error.code,
      config: error.config,
      response: error.response
        ? {
            status: error.response.status,
            statusText: error.response.statusText,
            headers: error.response.headers,
            data: error.response.data
          }
        : null,
    });

    const message =
      error.response?.data?.error ||
      error.message ||
      "Неизвестная ошибка";

    return { success: false, error: message };
  }
}
};

export default RegistrationService;